import React from 'react';
import { HeaderShopMenuProps } from '../interfaces';
import ShopMenuDropdown from './ShopMenuDropdown';
import './HeaderNavLink.scss';
import './HeaderShopMenu.scss';

const HeaderShopMenu: React.FC<HeaderShopMenuProps> = ({
  types,
  shopOpen,
  shopGender,
  currentGender,
  currentType,
  isProductsPage,
  usesHoverMenu,
  onOpen,
  onClose,
  onScheduleClose,
  onToggle,
  onGenderChange,
}) => {
  const suppressNextFocusOpenRef = React.useRef(false);

  const suppressNextFocusOpen = () => {
    suppressNextFocusOpenRef.current = true;
    window.setTimeout(() => {
      suppressNextFocusOpenRef.current = false;
    }, 0);
  };

  const handleClick = () => {
    if (usesHoverMenu) {
      onOpen();
      return;
    }

    onToggle();
  };

  return (
    <div
      className={`header-nav__shop ${shopOpen ? 'is-open' : ''}`}
      onMouseEnter={() => {
        if (usesHoverMenu) {
          onOpen();
        }
      }}
      onMouseLeave={() => {
        if (usesHoverMenu) {
          onScheduleClose();
        }
      }}
      onFocusCapture={() => {
        if (usesHoverMenu) {
          if (suppressNextFocusOpenRef.current) {
            suppressNextFocusOpenRef.current = false;
            return;
          }

          onOpen();
        }
      }}
      onBlurCapture={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node | null)) {
          onClose();
        }
      }}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          event.stopPropagation();
          suppressNextFocusOpen();
          onClose();
          event.currentTarget.querySelector<HTMLButtonElement>('.header-nav__shop-button')?.focus();
        }
      }}
    >
      <button
        type="button"
        className="header-nav__link header-nav__shop-button"
        aria-expanded={shopOpen}
        aria-haspopup="dialog"
        aria-controls="shop-catalog-menu"
        aria-label="Open catalog menu"
        onClick={handleClick}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            event.stopPropagation();
            suppressNextFocusOpen();
            onClose();
            event.currentTarget.blur();
          }
        }}
      >
        <span className="header-nav__shop-trigger">SHOP</span>
      </button>

      {shopOpen && (
        <ShopMenuDropdown
          types={types}
          shopGender={shopGender}
          currentGender={currentGender}
          currentType={currentType}
          isProductsPage={isProductsPage}
          onGenderChange={onGenderChange}
        />
      )}
    </div>
  );
};

export default HeaderShopMenu;
